/**
 * Created by ronmarsiano on 14/08/2018.
 */

function SocketsPlatformGroupsCtrl($scope, $filter, GeneralUtilsService){
    $scope.datamodified = false;
    $scope.versions= {};
    $scope.socketVersionHideLatest = true;
    $scope.ready = false;

    store.fetch({
        path: "/getReleaseGroups",
        success: function(data){
            $scope.releaseGroups = data;
            init();
        }
    });



    function init(){
        $scope.ready = true;

        var tableHeader = [
            {'label': 'Version', 'path': 'version', noSort: false},
            {'label': 'Platform', 'path': 'parsedVersion', noSort: true}
        ];

        $scope.releaseGroups.forEach(function (group) {
            tableHeader.push({'label': group, 'path': 'group', noSort: true});
        });

        $scope.$root.hasChanges = function(){
            if(!angular.equals($scope.orig,$scope.items)){
                return true;
            }
            return false;
        };

        $scope.tableConfig = {
            id: 'socketVersions',
            dataURL : function() {
                return "/ag/getSocketVersions";
            },
            alternativeHead: tableHeader,
            processData: function(items){
                items.forEach(function (version) {
                    parseSingleVersion(version);
                });
                $scope.orig = angular.copy(items);
                $scope.items = items;
            },
            fields : [{"label": "", "path": "parsedVersion", "template": "<admin-platform-group version-name='item.version' socket-version='item.parsed'></admin-platform-group>"}],
            type : "SocketVersion",
            pageSize: 10,
            actions: [],
            hideCheckboxes: true,
            editTable: true,
            titleSearch: "Versions",
            sortField: "version",
            sortDir: "DESC",
            hasChanges: function(){
                return $scope.$root.hasChanges();
            }
        };
    }


    /**
     * we create an object for each platform holding its groups
     * so we can display it later
     * @param versionStructure
     */
    function parseSingleVersion(versionStructure) {
        if(versionStructure){
            delete versionStructure.parsed;
            versionStructure.parsed = [];
            versionStructure.releasePlatforms.forEach(function (releasePlatform) {
                var curPlatform = {};
                versionStructure.parsed.push(curPlatform);
                curPlatform.platform = releasePlatform.platform;
                curPlatform.fileExists = versionStructure[releasePlatform.platform+'_fileExists'];
                curPlatform.groups = [];
                $scope.releaseGroups.forEach(function (releaseGroup) {
                    if(versionStructure[releasePlatform.platform+'_releaseGroups'] && versionStructure[releasePlatform.platform+'_releaseGroups'].indexOf(releaseGroup)> -1){
                        curPlatform.groups.push({name: releaseGroup, value: true});
                    }
                    else{
                        curPlatform.groups.push({name: releaseGroup, value: false});
                    }
                });
            });
        }
    }

    function collectSingleVersion(versionStructure) {
        versionStructure.parsed.forEach(function (singleStructure) {
            versionStructure[singleStructure.platform+'_releaseGroups']= function (list) {
                var ret = [];
                list.forEach(function (element) {
                    if(element.value == true){
                        ret.push(element.name);
                    }
                });
                return ret;
            }(singleStructure.groups);
        });
        delete versionStructure.parsed;
    }


    $scope.saveChanges = function(){
        $scope.loading = true;

        var itemsToSave = angular.copy($scope.tableConfig.items);
        itemsToSave.forEach(function(item){
            item.newSaveMethod = true;
            collectSingleVersion(item);
        });

        store.save({
            path: "/ag/saveSocketVersions",
            data: itemsToSave,
            dataObj: 'json',
            queryParams: {
            },
            success: function(data){
                $scope.$root.handleServerResponse(data, "" , 'Versions changes were saved successfully');
                if(data.data && data.data.items){
                    $scope.datamodified = new Date().getTime();
                }
                $scope.closePopup('changeGroupsConfirmation');
                $scope.loading = false;
            }
        });
    };
}